import React from 'react';
import './result.styles.scss';

const Result = ({result})=> (
    <div className="result">
        <p>
            {
                result
            }
        </p>

    </div>
)

export default Result;